'use strict';

var toastr = require('toastr');
var _ = require('lodash');
var OnlineLogitCalibrationReviewPanelController = function OnlineLogitCalibrationReviewPanelController($scope, $rootScope, $timeout, $log, momentService, constants, onlineLogitCalibrationReviewService, calibrationAnalysisConstants, userSecureService) {
  $scope.screen = constants.ONLINE_LOGIT_CALIBRATION_REVIEW_SCREEN;
  $scope.localUpdates = [];
  $scope.selectedView = [{
    name: 'fixed',
    selected: true
  }];
  $scope.classGroups = onlineLogitCalibrationReviewService.getClassGroups($scope.selectedCalibrationData.market);
  $scope.dows = calibrationAnalysisConstants.DOW;
  $scope.filter = {
    selectedClassGroup: $scope.classGroups[0],
    selectedDow: $scope.dows[0]
  };
  $scope.chartTypes = _.keys(calibrationAnalysisConstants.CHART_LABEL);
  $scope.reviewDataReady = false;
  $scope.isSaveButtonEnabled = false;
  $scope.isSaved = false;
  function hasCreationPermission() {
    return userSecureService.hasAuthorization('calibration-analysis', 'write');
  }
  $scope.isPublishButtonEnabled = function () {
    if (!hasCreationPermission()) {
      return false;
    }
    return $scope.selectedCalibrationData.assigned !== calibrationAnalysisConstants.CALIBRATION_STATUSES.PUBLISHED;
  };
  $scope.handleViewToggle = function (event, viewId) {
    $scope.selectedView = viewId;
    $scope.logitReviewData.contextData.viewType = viewId;
  };
  $scope.captureUpdates = function (event, updateKey) {
    $scope.localUpdates.push(updateKey);
    $scope.isSaveButtonEnabled = true;
    updateLogitReviewData(updateKey);
  };
  function updateLogitReviewData(updateKey) {
    var tokens = updateKey.split('.');
    var hepKey = _.join(_.dropRight(tokens), '.');
    var reviewData = _.isNil($scope.logitReviewData) ? null : _.find($scope.logitReviewData.logitParams, {
      key: hepKey
    });
    if ($scope.screenState.isOnlineLogitGridExpanded && !_.isNil(reviewData)) {
      var logitSharesRequest = onlineLogitCalibrationReviewService.prepareLogitSharesDataRequest($scope.selectedCalibrationData, $scope.filter, $scope.selectedView);
      $scope.logitReviewData = onlineLogitCalibrationReviewService.extractLogitDataForCharts($scope.logitSharesDataSet, logitSharesRequest);
    }
  }
  $scope.removeUpdates = function (event, updateKey) {
    _.remove($scope.localUpdates, function (key) {
      return key === updateKey;
    });
    $scope.isSaveButtonEnabled = !_.isEmpty($scope.localUpdates);
  };
  $scope.renderLogitSharesData = function () {
    var logitSharesRequest = onlineLogitCalibrationReviewService.prepareLogitSharesDataRequest($scope.selectedCalibrationData, $scope.filter, $scope.selectedView);
    onlineLogitCalibrationReviewService.retrieveLogitSharesData(logitSharesRequest).then(function (dataSet) {
      $scope.logitProfiles = dataSet[1];
      $scope.logitReviewData = onlineLogitCalibrationReviewService.extractLogitDataForCharts(dataSet, logitSharesRequest);
      $scope.reviewDataReady = true;
      $scope.logitSharesDataSet = dataSet;
    })["catch"](function (e) {
      logErrorMessage('renderLogitSharesData()', e);
      toastr.error('Error Occured While Retrieving Logit Shares Data');
    });
  };
  $scope.$watchGroup(['filter.selectedClassGroup', 'filter.selectedDow'], function (newValues, oldValues) {
    if (_.isEqual(newValues, oldValues)) {
      return;
    }
    $scope.renderLogitSharesData();
  });
  $scope.cleanUp = function () {
    onlineLogitCalibrationReviewService.invalidateDataCache();
  };
  $scope.discardCacheOnBackToCalibration = function () {
    onlineLogitCalibrationReviewService.invalidateDataCache();
    $scope.$emit('online-logit-calibration:back-to-calibration-screen');
  };
  $scope.showUnsavedChangesDialog = function () {
    if (_.isEmpty($scope.localUpdates)) {
      $scope.$emit('online-logit-calibration:back-to-calibration-screen');
    } else {
      $scope.$broadcast('save-modal:openModal', null, {
        name: 'app.calibration-analysis'
      }, {
        onNoBtnClick: $scope.discardCacheOnBackToCalibration
      });
    }
  };
  $scope.getLocalUpdatesAndSave = function (event, publishIndicator) {
    var updateKeys = _.chain($scope.localUpdates).map(function (key) {
      var tokens = key.split('.');
      return _.join(_.dropRight(tokens), '.');
    }).uniq().value();
    $scope.$broadcast('online-logit-calibration:get-updates', updateKeys, publishIndicator);
  };
  $scope.saveLogitProfiles = function (event, profiles, publishIndicator) {
    var market = $scope.selectedCalibrationData.market.split('-');
    var updateRequest = {
      publish: false,
      origin: market[0],
      destination: market[1],
      calibrationName: $scope.selectedCalibrationData.calibrationName
    };
    onlineLogitCalibrationReviewService.saveLogitProfiles(profiles, updateRequest).then(function () {
      toastr.success('Logit Shares Data Saved Successfully');
      $scope.localUpdates = [];
      $scope.isSaveButtonEnabled = false;
      if (publishIndicator) {
        publishLogitProfiles();
      } else {
        $scope.refreshGridAndChart();
      }
    })["catch"](function (e) {
      logErrorMessage('saveLogitProfiles()', e);
      toastr.error('Error Occured While Saving Logit Shares Data');
    });
  };
  $scope.publishProfile = function () {
    if (_.isEmpty($scope.localUpdates)) {
      publishLogitProfiles();
      return;
    }
    $scope.getLocalUpdatesAndSave(undefined, true);
  };
  function publishLogitProfiles() {
    onlineLogitCalibrationReviewService.publishProfiles($scope.selectedCalibrationData).then(function () {
      toastr.success('Publish Request Submitted Successfully');
      $scope.cleanUp();
      $scope.selectedCalibrationData.assigned = calibrationAnalysisConstants.CALIBRATION_STATUSES.PUBLISHED;
      $scope.$emit('online-logit-calibration:back-to-calibration-screen');
    })["catch"](function (e) {
      logErrorMessage('publishLogitProfiles()', e);
      toastr.error('Error Occured While Publishing Logit Shares Data');
    });
  }
  function logErrorMessage(methodName, error) {
    var msg = error.message || error.data && error.data.message;
    $log.error('OnlineLogitCalibrationReviewPanelController - ' + methodName + ' ' + msg);
  }
  $scope.refreshGridAndChart = function () {
    $timeout(function () {
      $scope.logitProfiles = [];
      $scope.logitReviewData = {};
      $scope.reviewDataReady = false;
      $scope.cleanUp();
      $scope.renderLogitSharesData();
      $rootScope.$broadcast('online-logit-calibration:reload-chart-and-grid');
    }, 10);
  };
};
OnlineLogitCalibrationReviewPanelController.$inject = ['$scope', '$rootScope', '$timeout', '$log', 'MomentService', 'DataRetrieverConstantsService', 'OnlineLogitCalibrationReviewService', 'CalibrationAnalysisConstants', 'UserSecureService'];
module.exports = OnlineLogitCalibrationReviewPanelController;